
export const defaultTableAttrs = {
  data: null,
  height: null,
  'max-height': null,
  stripe: false,
  border: false,
  size: null,
  fit: true,
  'show-header': true,
  'highlight-current-row': false,
  'current-row-key': null,
  'row-class-name': null,
  'row-style': null,
  'cell-class-name': null,
  'cell-style': null,
  'header-row-class-name': null,
  'header-row-style': null,
  'header-cell-class-name': null,
  'header-cell-style': null,
  'row-key': 'id',
  'empty-text': '暂无数据',
  'default-expand-all': false,
  'expand-row-keys': null,
  'default-sort': {},
  'tooltip-effect': null,
  'show-summary': false,
  'sum-text': '合计',
  'summary-method': null,
  'span-method': null,
  'default-expand-keys': null,
  'select-on-indeterminate': true,
  index: null,
  indent: 16,
  lazy: null,
  load: null,
  'tree-props': { hasChildren: 'hasChildren', children: 'children' }
}

/* 树表默认配置 */
export function genTreeConfig() {
  return {
    transform: false,
    rowField: 'id',
    parentField: 'parentId',
    children: 'children',
    indent: 20,
    line: false,
    expandAll: false,
    expandRowKeys: [],
    accordion: false,
    trigger: 'default',
    lazy: false,
    hasChild: 'hasChild',
    reserve: false,
    showIcon: true
  }
}

/* RowConfig */
export function genRowConfig() {
  return {
    useKey: false,
    keyField: '_X_ROW_KEY',
    isCurrent: true,
    isHover: false,
    height: null
  }
}

export const defaultVxeTableAttrs = () => ({
  id: null,
  data: null,
  height: null,
  'max-height': null,
  'auto-resize': true,
  'sync-resize': null,
  stripe: false,
  border: false,
  round: false,
  size: null,
  loading: false,
  resizable: false,
  virtual: false,
  align: 'left',
  'header-align': 'left',
  'footer-align': 'left',
  'show-header': true,
  'row-class-name': null,
  'cell-class-name': null,
  'header-row-class-name': null,
  'header-cell-class-name': null,
  'footer-row-class-name': null,
  'footer-cell-class-name': null,
  'cell-style': null,
  'header-cell-style': null,
  'footer-cell-style': null,
  'row-style': null,
  'header-row-style': null,
  'footer-row-style': null,
  'show-footer': null,
  'footer-method': null,
  'merge-cells': null,
  'merge-footer-items': null,
  'span-method': null,
  'footer-span-method': null,
  'show-overflow': false,
  'show-header-overflow': false,
  'show-footer-overflow': false,
  'keep-source': false,
  'empty-text': '',
  'keyboard-config': {
    isArrow: true
  },
  'column-config': {
    useKey: false,
    isCurrent: false,
    isHover: false,
    resizable: false,
    width: 'null',
    minWidth: 'null'
  },
  'row-config': {
    useKey: false,
    keyField: '_X_ROW_KEY',
    isCurrent: true,
    isHover: false,
    height: null
  },
  'resizable-config': null,
  'seq-config': genSeqConfig(),
  'sort-config': null,
  'filter-config': null,
  'export-config': null,
  'import-config': null,
  'print-config': null,
  'radio-config': {
    strict: true,
    reserve: true,
    highlight: true
  },
  'checkbox-config': {
    showHeader: true,
    checkAll: false,
    checkRowKeys: [],
    checkStrictly: false,
    strict: true,
    highlight: true,
    reserve: true,
    range: false
  },
  'tooltip-config': null,
  'menu-config': null,
  'expand-config': null,
  'tree-config': null,
  params: null
})

export function genSeqConfig() {
  return {
    startIndex: 1
  }
}

export function defaultFooterMethod({ columns, data }) {
  const sums = []
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = '合计'
      return
    }
    const values = data.map(item => Number(item[column.property]))
    if (!values.every(value => isNaN(value))) {
      sums[index] = values.reduce((prev, curr) => {
        const value = Number(curr)
        if (!isNaN(value)) {
          return prev + curr
        } else {
          return prev
        }
      }, 0)
    }
  })

  return [sums]
}

export function genTooltipConfig() {
  return {
    showAll: false,
    theme: 'dark',
    enterable: false,
    enterDelay: 500,
    leaveDelay: 300

  }
}

export const defaultColumn = {
  type: null,
  index: null,
  'column-key': null,
  label: null,
  prop: null,
  width: null,
  'min-width': null,
  fixed: null,
  'render-header': null,
  sortable: false,
  'sort-method': null,
  'sort-by': null,
  'sort-orders': ['ascending', 'descending', null],
  resizable: true,
  formatter: null,
  'show-overflow-tooltip': true,
  align: 'left',
  'header-align': null,
  'class-name': null,
  'label-class-name': null,
  selectable: null,
  'reserve-selection': false,
  filters: null,
  'filter-placement': null,
  'filter-multiple': true,
  'filter-method': null,
  'filtered-value': null
}

export const defaultPagination = {
  small: false,
  background: true,
  'page-size': 10,
  total: 0,
  'page-count': 0,
  'pager-count': 7,
  'current-page': 1,
  layout: 'total, sizes, prev, pager, next, jumper',
  'page-sizes': [10, 20, 30, 40, 50, 100],
  'popper-class': '',
  'prev-text': '',
  'next-text': '',
  disabled: false,
  'hide-on-single-page': false
}

export const densityConfig = [
  {
    label: '默认',
    value: ''
  },
  {
    label: '中等',
    value: 'medium'
  },
  {
    label: '紧凑',
    value: 'small'
  },
  {
    label: '迷你',
    value: 'mini'
  }
]
